import {Provider} from '@ethersproject/abstract-provider';
import {useEffect, useState} from 'react';
import {useWeb3Provider} from './useWeb3Provider';

const _cache: {[key: string]: string | null} = {};
async function cacheGet(provider: Provider, addr: string) {
  if (!(addr in _cache)) {
    const result = await provider.lookupAddress(addr);
    _cache[addr] = result;
  }

  return _cache[addr];
}

export function useResolveEnsName(address?: string | null, trimAddress = 8) {
  const _addr = address ? address.toLowerCase() : '';
  const [resolved, setResolved] = useState<string>((_addr || '').substring(0, trimAddress + 2));
  const {mainnetProvider} = useWeb3Provider();

  useEffect(() => {
    (async () => {
      if (mainnetProvider && _addr) {
        const result = await cacheGet(mainnetProvider, _addr);
        setResolved(result || _addr.substring(0, trimAddress + 2));
      }
    })();
  }, [_addr, mainnetProvider, trimAddress]);

  return resolved;
}
